module.exports = __webpack_public_path__ + "img/product2.9e849103.png";